<script setup lang="ts">
import {useTemplateRef, ref} from "vue";
import {Icon} from "@iconify/vue";
import StimulusDisplay from "@/Pages/User/Stimuli/StimulusDisplay.vue";
import Question from "@/Models/Question.ts";

const props = defineProps<{
    question: Question;
    points?: Array<{x: number; y: number; [key: string]: any}>;
    annotation?: any;
}>();

const emit = defineEmits(["pointClick"]);

const state = ref({
    show: {
        stimulusDetails: false,
    },
});
const container = useTemplateRef("container");
const stimulusBlock = useTemplateRef("stimulusBlock");
const stimulusDisplay = useTemplateRef("stimulusDisplay");

const pointClick = (point) => {
    emit("pointClick", point);
};

defineExpose({
    container,
    stimulusDisplay,
});
</script>

<template>
    <div class="w-full max-w-full" ref="container">
        <div v-if="question.stimuli.length" ref="stimulusBlock" class="" v-auto-animate>
            <div class="mb-1 flex w-full items-end">
                <h3 class="font-bold text-stone-500 dark:text-stone-400">Stimulus</h3>
                <div class="ml-auto flex justify-center">
                    <button
                        type="button"
                        class="flex items-center gap-1 text-xs"
                        @click="state.show.stimulusDetails = !state.show.stimulusDetails"
                    >
                        <Icon
                            :icon="state.show.stimulusDetails ? 'akar-icons:chevron-up' : 'akar-icons:chevron-down'"
                        />
                        {{ state.show.stimulusDetails ? "Hide" : "Show" }} details
                    </button>
                </div>
            </div>
            <div class="mb-4" v-if="state.show.stimulusDetails">
                <p class="text-xs font-bold uppercase">{{ question.stimulus.type.name }}</p>
                <h2 class="break-words font-bold">{{ question.stimulus.title }}</h2>
                <p class="break-words text-sm">{{ question.stimulus.description }}</p>
            </div>
            <div class="mb-8 border-b pb-3 dark:border-stone-500" v-auto-animate>
                <StimulusDisplay
                    ref="stimulusDisplay"
                    :question="question"
                    :stimulus="question.stimulus"
                    :points="points"
                    :annotation="annotation"
                    @point-click="pointClick"
                />
            </div>
        </div>
    </div>
</template>

<style scoped></style>
